import { Injectable, inject, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';

import {
  GroupDTO,
  GroupUserDTO,
  CreateGroupDTO,
  UpdateGroupDTO,
  RemoveUserFromGroupDTO,
  ResponseDTO
} from '../model/admin-dto';

@Injectable()
export class GroupsService {
  private readonly http = inject(HttpClient);
  private readonly PATH = 'api/group';

  private readonly groupsSignal = signal<GroupDTO[]>([]);
  private readonly loadingSignal = signal<boolean>(false);

  readonly groups = this.groupsSignal.asReadonly();
  readonly loading = this.loadingSignal.asReadonly();

  getGroupsList(): Observable<GroupDTO[]> {
    this.loadingSignal.set(true);

    return this.http.get<GroupDTO[]>(`${this.PATH}`).pipe(
      map((res) =>
        res.map((group) => ({
          ...group,
          usersCount: group.webRqaUsers.length
        }))
      )
    );
  }

  getGroupById(groupId: string): Observable<GroupDTO> {
    return this.http.get<GroupDTO>(`${this.PATH}/${groupId}`);
  }

  getGroupUsers(groupId: string): Observable<GroupUserDTO[]> {
    return this.http.get<GroupUserDTO[]>(`${this.PATH}/${groupId}/users`);
  }

  addGroup(group: CreateGroupDTO): Observable<ResponseDTO> {
    return this.http.post<ResponseDTO>(`${this.PATH}`, group);
  }

  updateGroup(group: UpdateGroupDTO): Observable<boolean> {
    return this.http.put<boolean>(`${this.PATH}/${group.id}`, group);
  }

  deleteGroup(groupId: string): Observable<boolean> {
    return this.http.delete<boolean>(`${this.PATH}/${groupId}`);
  }

  removeUserFromGroup(removeUserData: RemoveUserFromGroupDTO): Observable<boolean> {
    return this.http.delete<boolean>(`${this.PATH}/${removeUserData.groupId}/users/${removeUserData.username}`);
  }

  updateGroupsSignal(groups: GroupDTO[]): void {
    this.groupsSignal.set(groups);
    this.loadingSignal.set(false);
  }

  setLoading(loading: boolean): void {
    this.loadingSignal.set(loading);
  }
}
